<app-section-wrapper-container>
	<div class="overview-sub-section">
		<app-summary-item
			[title]="'staff|record|details-section|field-label|type'"
			[value]="
				this.recordData().type | getTranslationKeyFromValue: types | transloco
			"></app-summary-item>
	</div>
</app-section-wrapper-container>
